export const NOTIFICATION_BUTTON_DEFAULT_HEIGHT = 24
